import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent {
  constructor(private router: Router) {
  }

  blogs: any = [
    {
      title: 'Why Enroll Considered A Stressbuster for Admission Management Team',
      content: 'Higher education institutions frequently experience stress related to meeting enrollment targets, a backlog of applications, and manual data input as the admissions season draws near.',
      image: './assets/images/blogs-images/enroll-stressbuster.jpg'
    },
    {
      title: 'Maximize Efficiency with Enroll’s Innovative AMS Modules',
      content: 'With the introduction of bi-annual admissions across universities, the University Grants Commission (UGC) has taken a major step toward improving accessibility and efficiency in higher education.',
      image: './assets/images/blogs-images/maximize-efficiency.jpeg'
    },
    {
      title: 'Unlock New Potential with Enroll’s Comprehensive AMS Solution',
      content: 'Empower your team with tools designed to streamline admissions. Enroll’s AMS software provides everything you need for a more organized, efficient, and stress-free admissions process.',
      image: './assets/images/card-three.png'
    },
  ];

  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
